import { DocumentFileType, Errors } from '@equifinance/shared';

export enum Stage {
  Submission = 'Before Submission',
  Offer = 'Before Offer',
  Completion = 'Before Completion',
}

export enum Progress {
  Draft = 'Draft',
  PendingSubmission = 'Pending submission',
  OutstandingForBroker = 'Outstanding for broker',
  SubmittedToLender = 'Submitted to lender',
  MoreInformationRequired = 'More information required',
  Approved = 'Approved',
  ApprovedWithException = 'Approved with exception',
  Rejected = 'Rejected',
}

export enum DecisionOutcome {
  Approve = 'Approve',
  ApproveWithException = 'Approve with exception',
  MoreInformationRequired = 'More information required',
  Reject = 'Reject',
}

export enum Category {
  Application = 'Application',
  Applicant1 = 'Applicant 1',
  Applicant2 = 'Applicant 2',
}

export enum NoteType {
  Call = 'Call',
  Email = 'Email',
  SystemNote = 'SystemNote',
  General = 'General',
}

export enum DocumentStatus {
  Approved = 'Approved',
  ApprovedSubjectToExpiry = 'Approved (subject to expiry)',
  Uploaded = 'Uploaded',
  Deleted = 'Deleted',
  SubmittedToLender = 'Submitted To Lender',
  WithThirdParty = 'With Third Party',
  Rejected = 'Rejected',
  Expired = 'Expired',
  ToExpire = 'To Expire',
  UnderwriterDocument = 'UW Document',
}

export type WrittenEvidence = {
  id: string
  text: string
  evidenceFromUserId: string
  evidenceFromUserName: string
  moment: string
  isLocked: boolean
}

export type UnderWritingDecision = {
  id: string
  outcome: keyof typeof DecisionOutcome;
  outcomeReason: string
  outcomeDetail: string
  decisionByUserId: string
  decisionByUserName: string
  moment: string
  isLocked: boolean
}

export type DocumentEvidence = {
  documentId: string
  fileName: string
  documentType: keyof typeof DocumentFileType;
  uploadedDate: string
  expireDate: string
  status: keyof typeof DocumentStatus;
}

export type TaskDocument = {
  taskId?: string,
  fileName: string
  documentType: string;
  documentData: string;
}

export type UploadTaskDocumentPayload = {
  documents: TaskDocument[];
}

export type PostTaskNotePayload = {
  taskId: string,
  note: string,
  type: Exclude<NoteType, NoteType.SystemNote>,
  privateFlag: boolean,
}

export type PostWrittenEvidencePayload = {
  taskId: string,
  writtenEvidenceText: string,
}

export type Note = {
  id: string
  noteFromCompanyId: string
  noteFromCompanyName: string
  noteFromUserId: string
  noteFromUserName: string
  note: string
  type: keyof typeof NoteType;
  moment: string
}

export type Task = {
  id: string
  type: string
  stage: keyof typeof Stage;
  status: keyof typeof Progress;
  title: string
  description: string
  category: keyof typeof Category;
  templateTypes: string[]
  lastUpdated: string
  writtenEvidence: WrittenEvidence[]
  possibleDecisionOutcomes: (keyof typeof DecisionOutcome)[]
  currentUnderwritingDecision: UnderWritingDecision
  documentEvidence: DocumentEvidence[]
  notes: Note[]
  privateNotes: Note[]
  updated: boolean;
  canUpload?: boolean;
}

export type Tasks = {
  updateCount: number,
  dirtyCount: number,

  id: string
  tasks: Task[],
  errors: Errors,
};

export type TaskType = {
  taskTypeId: string,
  title: string,
  description: string,
  category: 'Application' | 'Applicant' | null,
  stage: keyof typeof Stage
};

export type TaskTypes = {
  taskTypes: TaskType[]
}

export type UnderwriterDecisionPayload = {
  taskId: string,
  decisionOutcome: keyof typeof DecisionOutcome,
  decisionOutcomeReason?: string,
  decisionOutcomeDetail?: string,
}
